import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { HBApi } from "./HBApi";
import {
  Card,
  CardBody,
  CardImg,
  CardTitle,
  Label,
  Button,
  Row,
  Col,
  Container,
  CardGroup,
} from "reactstrap";
import AppNavbarLight from "./AppNavbarLight";

const BookingInformation = () => {
  const { id } = useParams();
  const [bookingInformation, setBookingInformation] = useState({});
  useEffect(() => {
    HBApi.getBookingsById(id).then((data) => {
      console.log(`Received data : ${JSON.stringify(data)}`);
      setBookingInformation(data);
    });
  }, []);

  return (
    <Container>
      <Row>
        <Col md="12">
          <AppNavbarLight />
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <h1 align="center">Booking information</h1>
        </Col>
      </Row>
      <Row>
        <Col></Col>
        <Col></Col>
        <Col>Booked berth:</Col>
        <Col>{bookingInformation?.label}</Col>
        <Col></Col>
        <Col></Col>
      </Row>
      <Row>
        <Col></Col>
        <Col></Col>
        <Col>Arrival: </Col>
        <Col>{bookingInformation?.from}</Col>
        <Col></Col>
        <Col></Col>
      </Row>
      <Row>
        <Col></Col>
        <Col></Col>
        <Col>Departure: </Col>
        <Col>{bookingInformation?.to}</Col>
        <Col></Col>
        <Col></Col>
      </Row>
      <Row>
        <Col></Col>
        <Col></Col>
        <Col>Cancellable:</Col>
        <Col id="cancellable">
          {bookingInformation?.cancellable ? "Yes" : "No"}
        </Col>
        <Col></Col>
        <Col></Col>
      </Row>
      <Row>
        <Col></Col>
        <Col></Col>
        <Col>Boat name:</Col>
        <Col id="boatName">{bookingInformation?.boatName}</Col>
        <Col></Col>
        <Col></Col>
      </Row>
    </Container>
  );
};

export default BookingInformation;
